import {
    ContactAndCustomizeContainer,
    ButtonContainer,
    IconWrapper,
    ButtonText,
    LinkButtonContainer
} from './ContactAndCustomize.styles';
import {
    Airflow,
    ContactSupport,
    Language,
    Share
} from '@swegon-core/uic/dist/src/theme/icons/googleMaterialIcons';
import { Context as TranslationContext } from '../shared/contexts/TranslationContext';
import { useContext, useState } from 'react';
import { BLACK } from '@swegon-core/uic/dist/src/theme';
import ShareUnit from './ShareUnit';
import { Modal } from '@swegon-core/uic';
import { ContactForm, EmailData } from './ContactForm';
import { CountryDto } from './InputFieldsContainer';

export interface ContactAndCustomizeProps {
    productInfoUrl: string;
    onClickCustomize: () => void;
    onSendEmail: (emailData: EmailData) => void;
    shareUrl: string;
    countries: CountryDto[];
    preSelectedContactCountry: number;
}

export const ContactAndCustomize = (props: ContactAndCustomizeProps) => {
    const {
        productInfoUrl,
        onClickCustomize,
        onSendEmail,
        shareUrl,
        countries,
        preSelectedContactCountry
    } = props;
    const { l } = useContext(TranslationContext);
    const [shareIsVisible, setShareIsVisible] = useState(false);
    const [contactFormIsVisible, setContactFormIsVisible] = useState(false);

    const onSendEmailHandler = (data: EmailData) => {
        onSendEmail(data);
        setContactFormIsVisible(false);
    };

    return (
        <>
            <ContactAndCustomizeContainer>
                <LinkButtonContainer
                    id={'view-product-details-button'}
                    href={productInfoUrl}
                    referrerPolicy="no-referrer"
                    target="_blank"
                    role="button"
                    aria-label={l('ahudesign.viewProductDetails')}
                >
                    <IconWrapper>
                        <Language />
                    </IconWrapper>
                    <ButtonText>{l('ahudesign.viewProductDetails')}</ButtonText>
                </LinkButtonContainer>
                <ButtonContainer
                    role="button"
                    aria-label={l('ahuDesignLite.shareUnitButtonText')}
                    onClick={() => {
                        setShareIsVisible(true);
                    }}
                >
                    <IconWrapper>
                        <Share />
                    </IconWrapper>
                    <ButtonText>
                        {l('ahuDesignLite.shareUnitButtonText')}
                    </ButtonText>
                </ButtonContainer>
                <ButtonContainer
                    id={'open-form-contact-sales-button'}
                    role="button"
                    aria-label={l('ahudesign.contactSales')}
                    onClick={() => setContactFormIsVisible(true)}
                >
                    <IconWrapper>
                        <ContactSupport />
                    </IconWrapper>
                    <ButtonText>{l('ahudesign.contactSales')}</ButtonText>
                </ButtonContainer>
                <ButtonContainer
                    id={'customize-in-ahud-button'}
                    role="button"
                    aria-label={l('ahudesign.customizeInAHUDesign')}
                    onClick={onClickCustomize}
                >
                    <IconWrapper>
                        <Airflow color={BLACK} />
                    </IconWrapper>
                    <ButtonText>
                        {l('ahudesign.customizeInAHUDesign')}
                    </ButtonText>
                </ButtonContainer>
            </ContactAndCustomizeContainer>
            <Modal
                onClose={() => setShareIsVisible(false)}
                open={shareIsVisible}
            >
                <ShareUnit linkUrl={shareUrl} />
            </Modal>
            <Modal
                onClose={() => setContactFormIsVisible(false)}
                open={contactFormIsVisible}
                title={l('ahudesign.contactSales')}
            >
                <ContactForm
                    countries={countries}
                    onSendEmail={onSendEmailHandler}
                    preSelectedContactCountry={preSelectedContactCountry}
                />
            </Modal>
        </>
    );
};

export default ContactAndCustomize;
